import { GetQuotationDetailsRequest } from "../api/requests/get-quotation-details-request";
import { CreateOrderFromQuotationRequest } from "../api/requests/create-order-from-quotation-request";
import { CreateQuotationChangeRequestRequest } from "../api/requests/create-quotation-change-request-request";
import config from "../environment/environment-config";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";

/* Quotation header */
export const FETCH_QUOTATIONS_BEGIN = "FETCH_QUOTATIONS_BEGIN";
export const FETCH_QUOTATIONS_SUCCESS = "FETCH_QUOTATIONS_SUCCESS";
export const FETCH_QUOTATIONS_FAILURE = "FETCH_QUOTATIONS_FAILURE";

/* Quotation detail */
export const FETCH_QUOTATION_DETAILS_BEGIN = "FETCH_QUOTATION_DETAILS_BEGIN";
export const FETCH_QUOTATION_DETAILS_SUCCESS =
  "FETCH_QUOTATION_DETAILS_SUCCESS";
export const FETCH_QUOTATION_DETAILS_FAILURE =
  "FETCH_QUOTATION_DETAILS_FAILURE";

/* Quotation create change request */
export const CREATE_QUOTATION_CHANGE_REQUEST_BEGIN =
  "CREATE_QUOTATION_CHANGE_REQUEST_BEGIN";
export const CREATE_QUOTATION_CHANGE_REQUEST_SUCCESS =
  "CREATE_QUOTATION_CHANGE_REQUEST_SUCCESS";
export const CREATE_QUOTATION_CHANGE_REQUEST_FAILURE =
  "CREATE_QUOTATION_CHANGE_REQUEST_FAILURE";

/* Quotation create order */
export const CREATE_QUOTATION_ORDER_BEGIN = "CREATE_QUOTATION_ORDER_BEGIN";
export const CREATE_QUOTATION_ORDER_SUCCESS = "CREATE_QUOTATION_ORDER_SUCCESS";
export const CREATE_QUOTATION_ORDER_FAILURE = "CREATE_QUOTATION_ORDER_FAILURE";

export const QUOTATIONS_BASE_URL = config.apiUrls.quotationsApi;

/* Quotation header */
export const fetchQuotationsBegin = () => ({
  type: FETCH_QUOTATIONS_BEGIN,
});

export const fetchQuotationsSuccess = (response) => ({
  type: FETCH_QUOTATIONS_SUCCESS,
  payload: response,
});

export const fetchQuotationsFailure = (errors) => ({
  type: FETCH_QUOTATIONS_FAILURE,
  payload: { errors },
});

/* quotation detail */
export const fetchQuotationDetailsBegin = (guid) => ({
  type: FETCH_QUOTATION_DETAILS_BEGIN,
  payload: { guid },
});

export const fetchQuotationDetailsSuccess = (guid, response) => ({
  type: FETCH_QUOTATION_DETAILS_SUCCESS,
  payload: { guid, response },
});

export const fetchQuotationDetailsFailure = (guid) => ({
  type: FETCH_QUOTATION_DETAILS_FAILURE,
  payload: { guid },
});

/* quotation change request */
export const createQuotationChangeRequestBegin = (guid) => ({
  type: CREATE_QUOTATION_CHANGE_REQUEST_BEGIN,
  payload: { guid },
});

export const createQuotationChangeRequestSuccess = (guid, response) => ({
  type: CREATE_QUOTATION_CHANGE_REQUEST_SUCCESS,
  payload: { guid, response },
});

export const createQuotationChangeRequestFailure = (guid, error) => ({
  type: CREATE_QUOTATION_CHANGE_REQUEST_FAILURE,
  payload: { guid, error },
});

/* quotation create order */
export const createQuotationOrderBegin = (guid) => ({
  type: CREATE_QUOTATION_ORDER_BEGIN,
  payload: { guid },
});

export const createQuotationOrderSuccess = (guid, response) => ({
  type: CREATE_QUOTATION_ORDER_SUCCESS,
  payload: { guid, response },
});

export const createQuotationOrderFailure = (guid, error) => ({
  type: CREATE_QUOTATION_ORDER_FAILURE,
  payload: { guid, error },
});

export function getQuotations() {
  const url = QUOTATIONS_BASE_URL;
  return (dispatch) => {
    dispatch(fetchQuotationsBegin());
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        } else {
          return res.json();
        }
      })
      .then((data) => {
        dispatch(fetchQuotationsSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchQuotationsFailure(messages));
        });
      });
  };
}

export function getQuotationDetails(request: GetQuotationDetailsRequest) {
  const url = QUOTATIONS_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchQuotationDetailsBegin(request.guid));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then((data) => {
        dispatch(fetchQuotationDetailsSuccess(request.guid, data));
        return data;
      })
      .catch(() => {
        dispatch(fetchQuotationDetailsFailure(request.guid));
      });
  };
}

export function createQuotationChangeRequest(
  request: CreateQuotationChangeRequestRequest
) {
  const url = QUOTATIONS_BASE_URL + `/${request.orderNumber}/change`;
  return async (dispatch) => {
    dispatch(createQuotationChangeRequestBegin(request.guid));
    const response = await fetch(url, {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify(request),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json();
      dispatch(createQuotationChangeRequestSuccess(request.guid, data));
    } else {
      let data = undefined;

      try {
        data = await response.json();
      } catch (error) {}

      dispatch(
        createQuotationChangeRequestFailure(
          request.guid,
          data && "text" in data ? data.text : undefined
        )
      );
    }
  };
}

export function createQuotationOrder(request: CreateOrderFromQuotationRequest) {
  const url = QUOTATIONS_BASE_URL + `/${request.orderNumber}/checkout`;
  return async (dispatch) => {
    dispatch(createQuotationOrderBegin(request.guid));
    const response = await fetch(url, {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify(request),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json();
      dispatch(createQuotationOrderSuccess(request.guid, data));
    } else {
      let data = undefined;

      try {
        data = await response.json();
      } catch (error) {}

      dispatch(
        createQuotationOrderFailure(
          request.guid,
          data && "text" in data ? data.text : undefined
        )
      );
    }
  };
}
